module.exports = {
  ontario: 'ON',
  quebec: 'QC',
  nova_scotia: 'NS',
  new_brunswick: 'NB',
  manitoba: 'MB',
  british_columbia: 'BC',
  prince_edward_island: 'PE',
  saskatchewan: 'SK',
  alberta: 'AB',
  newfoundland_and_labrador: 'NL',
  northwest_territories: 'NT',
  yukon: 'YT',
  nunavut: 'NU'
};
